var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFXtz(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2070_19240)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.601562 8.36881L13.818 0.738281L27.0345 8.36881V23.6299L13.818 31.2604L0.601562 23.6299V8.36881Z",
    stroke: "url(#paint0_linear_2070_19240)",
    strokeWidth: 1.45455
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2070_19240",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 24,
    height: 28
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8178 2.87109L25.1864 9.43473V22.562L13.8178 29.1256L2.44922 22.562V9.43473L13.8178 2.87109Z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2070_19240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8182 29.818C21.4498 29.818 27.6364 23.6314 27.6364 15.9998C27.6364 8.36825 21.4498 2.18164 13.8182 2.18164C6.18661 2.18164 0 8.36825 0 15.9998C0 23.6314 6.18661 29.818 13.8182 29.818Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8778 24C14.6904 24 13.8249 23.731 13.2814 23.176C12.738 22.6209 12.475 22.0401 12.475 21.3991C12.475 21.1731 12.5194 20.9728 12.6228 20.8155C12.7113 20.6581 12.8413 20.5322 13.0038 20.4463C13.1662 20.3605 13.3701 20.3033 13.6064 20.3033C13.8426 20.3033 14.0465 20.3462 14.209 20.4463C14.3714 20.5322 14.5014 20.6581 14.59 20.8155C14.6786 20.9728 14.7377 21.1702 14.7377 21.3991C14.7377 21.6824 14.6638 21.9113 14.5309 22.0801C14.3979 22.2518 14.2237 22.3777 14.0317 22.4349C14.1942 22.6466 14.4571 22.804 14.8086 22.9042C15.1601 23.0043 15.5115 23.0473 15.8661 23.0473C16.3653 23.0473 16.8054 22.9185 17.2011 22.6638C17.597 22.4092 17.8894 22.0258 18.0814 21.5279C18.2734 21.0301 18.3591 20.4635 18.3591 19.8226C18.3591 19.1273 18.2557 18.5437 18.0519 18.0601C17.8452 17.5622 17.5527 17.1931 17.1569 16.9671C16.7611 16.7268 16.3357 16.6123 15.8661 16.6123C15.5589 16.6123 15.1926 16.741 14.7377 16.9814L13.9106 17.3648V16.9671L17.6502 12.1373H12.475V17.1531C12.475 17.5651 12.5637 17.9056 12.7527 18.1774C12.9447 18.4464 13.2372 18.5752 13.6182 18.5752C13.9255 18.5752 14.2059 18.475 14.4837 18.2776C14.7613 18.0772 14.9977 17.8369 15.2014 17.568C15.231 17.5108 15.2605 17.4679 15.2901 17.4535C15.3344 17.4249 15.3639 17.4106 15.4082 17.4106C15.4821 17.4106 15.556 17.4392 15.6564 17.5108C15.7449 17.6109 15.7893 17.7225 15.7893 17.8513C15.7893 17.9084 15.7597 17.9943 15.7449 18.1059C15.5382 18.5751 15.2457 18.9299 14.8647 19.1702C14.4837 19.4106 14.0731 19.5394 13.6182 19.5394C12.4898 19.5394 11.7248 19.3276 11.2846 18.9013C10.8593 18.475 10.6407 17.8912 10.6407 17.1673V12.1373H8V11.1989H10.6554V9.06724L10.0529 8.48355V8H11.8135L12.4721 8.32619V11.1846L19.3221 11.1702L19.9955 11.8226L15.804 15.9028C16.0521 15.8026 16.3179 15.7453 16.5957 15.7168C17.0505 15.7168 17.5645 15.8598 18.1198 16.1431C18.6929 16.412 19.133 16.7954 19.4402 17.2789C19.7474 17.7625 19.9542 18.2175 20.0427 18.658C20.1314 19.0987 20.1905 19.4821 20.1905 19.837C20.1905 20.618 20.0133 21.3419 19.6764 22.0114C19.3398 22.6781 18.8258 23.1903 18.1227 23.5165C17.4316 23.8426 16.6842 24 15.8778 24Z",
    fill: "black",
    fillOpacity: 0.67
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2070_19240",
    x1: -9.31078,
    y1: 15.9994,
    x2: 30.3386,
    y2: 15.9994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05E3B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184658,
    stopColor: "#39E4B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C7BCC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2070_19240"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.6364,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFXtz);
export default __webpack_public_path__ + "static/media/fXTZ.7a1cdce1de04e81c45af8b686c6310d1.svg";
export { ForwardRef as ReactComponent };